import { render, staticRenderFns } from "./DatePage.vue?vue&type=template&id=b763e790&"
import script from "./DatePage.vue?vue&type=script&lang=js&"
export * from "./DatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports